<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Pinned Message Details</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <button type="submit" class="btn btn-warning btn-fill" @click="editPinnedMsg">Edit Pinned Message</button>
                </div>
            </div>
            <div class="table-responsive" v-if="pinnedMsg">
                <table class="table table-bordered table-light">
                    <tr>
                  <th>Id</th>
                  <td>{{pinnedMsg.corpAdminMessageId}}</td>
                </tr>
                  <tr>
                    <th>Corporation</th>
                    <td>{{pinnedMsg.corporationName}}</td>
                  </tr>
                  <tr>
                    <th>Message</th>
                    <td>{{pinnedMsg.corpAdminMessage}}</td>
                  </tr>
                  <tr>
                    <th>Create By</th>
                    <td>{{pinnedMsg.msgSenderName}}</td>
                  </tr>
                  <tr>
                    <th>Date</th>
                    <td>{{pinnedMsg.msgSentDateFmt}}</td>
                  </tr>
                    <tr>
                        <th>Status</th>
                        <td v-if="pinnedMsg.active == '0'">Inactive</td>
                        <td v-else>Active</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'ViewpinnedMsg',
        components: {
            LTable,
        },
        created (){
        this.$store.dispatch('GETSELECTEDPINNEDMSG', this.$route.params.id).then(() =>{
            console.log('selected', this.selectedPinnedMsg)
            this.pinnedMsg = this.selectedPinnedMsg;
        })
    },
    data () {
        return {
          pinnedMsg: {}
        }
    },
    methods: {
        editPinnedMsg(){
            this.$router.push({ name: 'EditPinnedMsg', params: { id: this.pinnedMsg.corpAdminMessageId}})
        },
    },
    computed: {...mapGetters([
        'selectedPinnedMsg'])
    }
    }
</script>

<style>
    th{
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PinnedMsgs/PinnedMsgDetails.vue